// All them icons
import React from 'react';
import './styles.scss';

import aboutUsExtensible from './icons/aboutUsExtensible.svg';
import aboutUsModular from './icons/aboutUsModule.svg';
import aboutUsOpenSource from './icons/aboutUsOpenSource.svg';
import aboutUsReusable from './icons/aboutUsReusable.svg';
import arrowDownNavbar from './icons/arrow_down_navbar.svg';
import arrowDown from './icons/arrow_down.svg';
import arrowLeftBlack from './icons/arrow-left-black.svg';
import arrowLeftBlue from './icons/arrow-left-blue.svg';
import arrowLeftRound from './icons/arrow_left_round.svg';
import arrowRight from './icons/arrow_right.svg';
import arrowRightBlack from './icons/arrow-right-black.svg';
import arrowRightMagenta from './icons/arrow_right_magenta.svg';
import arrowRightRound from './icons/arrow_right_round.svg';
import arrowsRight from './icons/arrows_right.svg';
import assistance from './icons/icon_assistance.svg';
import barGraph from './icons/bar_graph.svg';
import bigData from './icons/big-data.svg';
import cardStack from './icons/card_stack.svg';
import checkmark from './icons/checkmark.svg';
import chevronGrey from './icons/chevron-grey.svg';
import chevronMagenta from './icons/chevron-magenta.svg';
import cloudWeather from './icons/cloud-weather.svg';
import cloud from './icons/cloud.svg';
import cloudSquare from './icons/cloud_square.svg';
import cog from './icons/cog.svg';
import copy from './icons/copy.svg';
import customizable from './icons/customizable.svg';
import data from './icons/data.svg';
import database from './icons/database.svg';
import dna from './icons/dna.svg';
import download from './icons/download.svg';
import emailUs from './icons/email-us.svg';
import exploreDocs from './icons/explore-docs.svg';
import extensible from './icons/extensible.svg';
import feedback from './icons/icon_feedback.svg';
import fingerSnap from './icons/finger_snap.svg';
import githubGrey from './icons/github_grey.svg';
import githubMagenta from './icons/github_magenta.svg';
import githubWhite from './icons/github_white.svg';
import githubYellow from './icons/github_yellow.svg';
import githubFindUs from './icons/github-find-us.svg';
import graphCycle from './icons/graph_cycle.svg';
import gridGlass from './icons/grid_magnifying_glass.svg';
import history from './icons/history.svg';
import identifyNeeds from './icons/identify-needs.svg';
import joinCommunity from './icons/join-community.svg';
import kafka from './icons/kafka.svg';
import lock from './icons/lock.svg';
import lockCode from './icons/lock_code.svg';
import magnify from './icons/magnify.svg';
import mail from './icons/mail.png';
import notes from './icons/notes.svg';
import notes2 from './icons/notes2.svg';
import pageWhite from './icons/page_white.svg';
import palette from './icons/palette.svg';
import play from './icons/play.svg';
import power from './icons/power.svg';
import productAdministrativeUI from './icons/productAdministrativeUI.svg';
import productArranger from './icons/productArranger.svg';
import productArrangerWhite from './icons/productArrangerWhite.svg';
import productBilling from './icons/productBilling.svg';
import productBillingWhite from './icons/productBillingWhite.svg';
import productBuiltInUIComponents from './icons/productBuiltInUIComponents.svg';
import productCloudSupport from './icons/productCloudSupport.svg';
import productDMS from './icons/productDMS.svg';
import productDMSWhite from './icons/productDMSWhite.svg';
import productEgo from './icons/productEgo.svg';
import productEgoWhite from './icons/productEgoWhite.svg';
import productEnrolment from './icons/productEnrolment.svg';
import productEnrolmentWhite from './icons/productEnrolmentWhite.svg';
import productHighTransfer from './icons/productHighTransfer.svg';
import productJukebox from './icons/productJukebox.svg';
import productJukeboxWhite from './icons/productJukeboxWhite.svg';
import productMaestro from './icons/productMaestro.svg';
import productMaestroWhite from './icons/productMaestroWhite.svg';
import productMetadataTracking from './icons/productMetadataTracking.svg';
import productMetadataValidation from './icons/productMetadataValidation.svg';
import productMultipleIndexLevels from './icons/productMultipleIndexLevels.svg';
import productMultipleSongsIndex from './icons/productMultipleSongsIndex.svg';
import productOnco from './icons/productOnco.svg';
import productOncoWhite from './icons/productOncoWhite.svg';
import productPersona from './icons/productPersona.svg';
import productPersonaWhite from './icons/productPersonaWhite.svg';
import productRiff from './icons/productRiff.svg';
import productRiffWhite from './icons/productRiffWhite.svg';
import productSamtools from './icons/productSamtools.svg';
import productScalable from './icons/productScalable.svg';
import productScore from './icons/productScore.svg';
import productScoreWhite from './icons/productScoreWhite.svg';
import productSearchAPI from './icons/productSearchAPI.svg';
import productSingleSignOn from './icons/productSingleSignOn.svg';
import productSlackIntegration from './icons/productSlackIntegration.svg';
import productSong from './icons/productSong.svg';
import productSongWhite from './icons/productSongWhite.svg';
import productStateControls from './icons/productStateControls.svg';
import productStateless from './icons/productStateless.svg';
import rocketWhite from './icons/rocket_white.svg';
import search from './icons/search.svg';
import searchBar from './icons/searchBar.svg';
import security from './icons/security.svg';
import share from './icons/share.svg';
import shield from './icons/shield.svg';
import slack from './icons/icon_slack.svg';
import slackJoin from './icons/slack-join.svg';
import smileyFace from './icons/smileyFace.svg';
import slackNew from './icons/icon_slack_new.svg';
import softwareEngineers from './icons/software-engineers.svg';
import spiral from './icons/spiral.svg';
import star from './icons/star.svg';
import support from './icons/icon_support.svg';
import target from './icons/target.svg';
import unsmileyFace from './icons/unsmileyFace.svg';
import user from './icons/user.svg';
import vennDiagram from './icons/venn_diagram.svg';
import xGrey from './icons/x-grey.svg';

const icons = {
  aboutUsExtensible,
  aboutUsModular,
  aboutUsOpenSource,
  aboutUsReusable,
  arrowDownNavbar,
  arrowDown,
  arrowLeftBlack,
  arrowLeftBlue,
  arrowLeftRound,
  arrowRight,
  arrowRightBlack,
  arrowRightMagenta,
  arrowRightRound,
  arrowsRight,
  assistance,
  barGraph,
  bigData,
  cardStack,
  checkmark,
  chevronGrey,
  chevronMagenta,
  cloud,
  cloudWeather,
  cloudSquare,
  cog,
  copy,
  customizable,
  data,
  database,
  dna,
  download,
  exploreDocs,
  extensible,
  emailUs,
  feedback,
  fingerSnap,
  githubGrey,
  githubMagenta,
  githubWhite,
  githubYellow,
  githubFindUs,
  graphCycle,
  gridGlass,
  history,
  identifyNeeds,
  joinCommunity,
  kafka,
  lock,
  lockCode,
  magnify,
  mail,
  notes,
  notes2,
  pageWhite,
  palette,
  play,
  power,
  productAdministrativeUI,
  productArranger,
  productArrangerWhite,
  productBilling,
  productBillingWhite,
  productBuiltInUIComponents,
  productCloudSupport,
  productDMS,
  productDMSWhite,
  productEgo,
  productEgoWhite,
  productEnrolment,
  productEnrolmentWhite,
  productHighTransfer,
  productJukebox,
  productJukeboxWhite,
  productMaestro,
  productMaestroWhite,
  productMetadataTracking,
  productMetadataValidation,
  productMultipleIndexLevels,
  productMultipleSongsIndex,
  productOnco,
  productOncoWhite,
  productPersona,
  productPersonaWhite,
  productRiff,
  productRiffWhite,
  productSamtools,
  productScalable,
  productScore,
  productScoreWhite,
  productSearchAPI,
  productSingleSignOn,
  productSlackIntegration,
  productSong,
  productSongWhite,
  productStateControls,
  productStateless,
  rocketWhite,
  search,
  searchBar,
  security,
  share,
  shield,
  slack,
  slackJoin,
  slackNew,
  smileyFace,
  softwareEngineers,
  spiral,
  star,
  support,
  target,
  unsmileyFace,
  user,
  vennDiagram,
  xGrey,
};

export const Icon = ({ alt = '', img, size, className, style }) => (
  <img
    alt={alt}
    className={`${className ? className : ''} Icon`}
    src={icons[img]}
    style={{ width: size, height: 'auto', ...style }}
  />
);

// Common Icon sets / groups

function Core() {
  return (
    <span className="Icons">
      <div className="core">
        <Icon className="" img="star" alt="" /> CORE{' '}
      </div>
    </span>
  );
}

export const IconCommon = {
  Core,
};
